export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/homeIcon.95ea8abf.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};